import { render, staticRenderFns } from "./payeeRouteBankwise.vue?vue&type=template&id=252369c1&scoped=true"
import script from "./payeeRouteBankwise.vue?vue&type=script&lang=js"
export * from "./payeeRouteBankwise.vue?vue&type=script&lang=js"
import style0 from "./payeeRouteBankwise.vue?vue&type=style&index=0&id=252369c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252369c1",
  null
  
)

export default component.exports